import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { DeclaracoesFiscaisMensais } from '../../../models/declaracoesFiscaisMensais.model';
import { DeclaracoesFiscaisAnuais } from '../../../models/declaracoesFiscaisAnuais.model';
import { Router } from '@angular/router';
import { DeclaracoesFiscaisService } from '../../../services/declaracoes-fiscais.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { Icones } from '../../../shared/variaveisDeRotas';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';

@Component({
  selector: 'app-listar-declaracoes-fiscais',
  templateUrl: './listar-declaracoes-fiscais.component.html',
  styleUrls: ['./listar-declaracoes-fiscais.component.scss']
})
export class ListarDeclaracoesFiscaisComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  @ViewChild('dtMensal') dtMensal: Table | undefined;
  @ViewChild('dtAnual') dtAnual: Table | undefined;

  declaracoesFiscaisMensais: DeclaracoesFiscaisMensais[] = [];
  declaracoesFiscaisAnuais: DeclaracoesFiscaisAnuais[] = [];
  activeTab: number = 0;
  loading: boolean = false;
  declaracaoAbertaId: string | null = null;
  userId: string;

  constructor(
    private router: Router,
    private declaracoesFiscaisService: DeclaracoesFiscaisService,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private jwtHelper: JwtHelper,
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Declarações Fiscais');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('declaracoesFiscais').titulo);
    this.textoDescricao.emit(retornaDescricao('declaracoesFiscais').texto);
    this.mostrarDescricao.emit(true)
    this.carregarDeclaracoesFiscais();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  formatarMesAnoPorIdDeclaracao(idDeclaracao: string): string {
  if (!idDeclaracao || idDeclaracao.length < 14) return '';
  const ano = idDeclaracao.substring(8, 12);
  const mes = idDeclaracao.substring(12, 14);
  return `${mes}/${ano}`;
}

  carregarDeclaracoesFiscais() {
    this.spinnerService.show('Carregando declarações...');
    this.declaracoesFiscaisService.listarDeclaracoesMensais(this.userId).subscribe({
      next: (declaracoes) => {
        const declaracoesFiltradas = declaracoes.filter(declaracao =>
          declaracao.declaracaoTransmitida?.declaracao &&
          declaracao.declaracaoTransmitida?.recibo &&
          declaracao.declaracaoTransmitida.declaracao.trim() !== '' &&
          declaracao.declaracaoTransmitida.recibo.trim() !== ''
        );

        declaracoesFiltradas.forEach((declaracao, index) => {
        });

        this.declaracoesFiscaisMensais = declaracoesFiltradas.map(declaracao => {
          let mesAno = '';
          const isManual = (declaracao.nomeObrigacao && declaracao.nomeObrigacao.trim() !== '') ||
                          (declaracao.competencia && declaracao.competencia.trim() !== '');
          if (declaracao.competencia && declaracao.competencia.trim() !== '') {
            mesAno = declaracao.competencia;
          } else if (declaracao.declaracaoTransmitida?.idDeclaracao) {
            mesAno = this.formatarMesAnoPorIdDeclaracao(declaracao.declaracaoTransmitida.idDeclaracao);
          }
          const obrigacao = declaracao.nomeObrigacao && declaracao.nomeObrigacao.trim() !== ''
            ? declaracao.nomeObrigacao
            : 'PGDASD';

          return {
            ...declaracao,
            obrigacao: obrigacao,
            mesAno: mesAno,
            isManual: isManual
          };
        });
        this.spinnerService.hide();
      },
      error: (error) => {
        console.error('Erro ao carregar declarações mensais:', error);
        this.toastService.setMensagemToast('Erro ao carregar declarações mensais.', SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });
  }

  baixarPdf(base64: string, tipo: string, idDeclaracao?: string, nomeArquivo?: string): void {

    if (!base64 || base64.trim() === '') {
      console.error('Base64 está vazio ou nulo');
      this.toastService.setMensagemToast('Erro: Dados do arquivo não encontrados.', SeveridadeToast.Error);
      return;
    }

    try {
      let cleanBase64 = base64.trim();
      if (cleanBase64.startsWith('data:application/pdf;base64,')) {
        cleanBase64 = cleanBase64.replace('data:application/pdf;base64,', '');
      }
      cleanBase64 = cleanBase64.replace(/\s/g, '');

      const byteCharacters = atob(cleanBase64);

      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      if (blob.size === 0) {
        throw new Error('Arquivo gerado está vazio');
      }

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      if (nomeArquivo && nomeArquivo.trim() !== '') {
        a.download = nomeArquivo;
      } else {
        a.download = `${tipo}_${idDeclaracao || 'documento'}.pdf`;
      }
      a.style.display = 'none';
      a.target = '_blank';

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      this.toastService.setMensagemToast(`${tipo} baixado com sucesso!`, SeveridadeToast.Success);
    } catch (error) {
      console.error('Erro durante o download:', error);
      this.toastService.setMensagemToast(`Erro ao baixar ${tipo}: ${error}`, SeveridadeToast.Error);
    }
  }

  applyFilterGlobal(value: string): void {
    if (this.activeTab === 0 && this.dtMensal) {
      this.dtMensal.filterGlobal(value, 'contains');
    } else if (this.activeTab === 1 && this.dtAnual) {
      this.dtAnual.filterGlobal(value, 'contains');
    }
  }

  onTabChange(event: any) {
    this.activeTab = event.index;
  }

  verDetalhes(index: number) {
    const declaracaoSelecionada = this.declaracoesFiscaisMensais[index];

    if (declaracaoSelecionada) {
      this.declaracoesFiscaisService.setDeclaracaoSelecionada(declaracaoSelecionada);
      this.router.navigate(['/detalhes-declaracoes-fiscais']);
    } else {
      console.error('Declaração não encontrada');
    }
  }
}
